import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Card } from 'react-bootstrap';
import styles from './user-card.module.sass';
import * as React from 'react';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { useProjects, UserForm, useTools, useUser } from '../../../components';

export interface NewUserCardProps {
    updateCallbackTrigger: (clearActiveUser?: boolean) => void;
}

export const NewUserCard: FC<NewUserCardProps> = observer((props: NewUserCardProps) => {

    const loadToolsResult = useTools();
    const loadProjectsResult = useProjects();
    const loadUserResult = useUser(undefined);

    return !loadUserResult.isLoaded || !loadProjectsResult.isLoaded || !loadToolsResult.isLoaded
        ? <CustomSpinner spinnerText="Loading User..." />
        : loadUserResult.user &&
        loadProjectsResult.projects &&
        loadToolsResult.tools &&
        <Card key={loadUserResult.user.id} className={styles.userCard}>
            <Card.Body className={styles.cardBody}>
                <UserForm projects={loadProjectsResult.projects} tools={loadToolsResult.tools}
                          user={loadUserResult.user}
                          updateCallbackTrigger={props.updateCallbackTrigger} />
            </Card.Body>
        </Card>;
});
